import React from 'react';
import { Box, Tooltip, Badge } from '@mui/material';
import { AutoAwesomeRounded as AutoAwesomeIcon } from '@mui/icons-material';

interface CopilotLauncherProps {
  isOpen: boolean;
  onClick: () => void;
  hasMessages: boolean;
  messageCount: number;
}

export const CopilotLauncher: React.FC<CopilotLauncherProps> = React.memo(
  ({ isOpen, onClick, hasMessages, messageCount }) => {
    return (
      <Tooltip title={isOpen ? 'Close Copilot' : 'Open LOGIX Copilot'}>
        <Badge
          badgeContent={!isOpen && hasMessages ? messageCount : 0}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          sx={{
            position: 'fixed',
            top: '50%',
            transform: 'translateY(-50%)',
            right: isOpen ? 360 : 0,
            zIndex: theme => theme.zIndex.fab,
            transition: 'right 0.3s cubic-bezier(0.4, 0, 0.2, 1), transform 0.2s ease, box-shadow 0.2s ease',
            '& .MuiBadge-badge': {
              backgroundColor: 'secondary.main',
              color: 'secondary.contrastText',
            },
          }}
        >
          <Box
            onClick={onClick}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick();
              }
            }}
            role="button"
            tabIndex={0}
            aria-label={isOpen ? 'Close LOGIX Copilot' : 'Open LOGIX Copilot'}
            aria-haspopup="dialog"
            aria-expanded={isOpen}
            sx={{
              width: 44,
              height: 48,
              borderRadius: '24px 0px 0px 24px',
              backgroundColor: 'primary.main',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '-4px 0px 16px rgba(0, 0, 0, 0.15)',
              color: 'white',
              cursor: 'pointer',
              paddingRight: 0.5,
              border: '2px solid transparent',
              borderRight: 'none',
              transition: 'all 0.2s ease',
              '&:hover': {
                backgroundColor: 'primary.dark',
                transform: 'scale(1.05)',
              },
              '&:active': {
                transform: 'scale(0.95)',
              },
              '&:focus-visible': {
                outline: '3px solid #00C853',
                outlineOffset: '2px',
              },
            }}
          >
            <AutoAwesomeIcon sx={{ fontSize: 24 }} />
          </Box>
        </Badge>
      </Tooltip>
    );
  },
);

CopilotLauncher.displayName = 'CopilotLauncher';
